import { BrowserRouter, Routes, Route } from "react-router"

import Dashboard from "./components/Dashboard"
import Login from "./components/Login";
import LoginPage from "./components/LoginPage";
import Home from "./components/Home";

import PrivateRoute from "./components/PrivateRoute";
import AllSoftware from "./components/AllSoftware";
import AllInOne from "./components/AllInOne";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route element={<PrivateRoute />}>
          <Route path="/home" element={<Home />} />
          {/* <Route path="/home" element={<AllInOne />} /> */}
          {/* <Route path="/home" element={<AllSoftware />} /> */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
